<ng-container *transloco="let t; prefix: 'services.property-selector'">
    <div class="md:h-[calc(100vh-200px)] h-[calc(100vh-250px)] flex flex-col justify-between">
        <div class="flex flex-1 w-full self-start overflow-y-auto md:pt-20 pt-14 px-2">
            <div class="flex flex-col flex-1 rfs:gap-14 items-center">
                <progress-stepper class="progress-stepper-onboarding" *ngIf="Steps.length > 0" [Steps]="this.Steps"
                    [StepNo]='1' />
                <div class="flex flex-col w-full gap-2 items-center justify-center">
                    <h2 class="rfs:text-[40px] text-center font-semibold text-black">
                        {{t('header')}}
                    </h2>
                    <p class="rfs:text-xl text-center font-light text-tone-09">
                        {{t('infoText')}}
                    </p>
                </div>
                @if (!isLoading) {
                <div class="flex justify-center w-full max-w-[800px]">
                    <app-tab-pill-group-button *ngIf="tabPillGroupButtons.length > 0" class="flex-1"
                        [items]="tabPillGroupButtons" (itemSelected)="handleButtonGroupItemSelected($event)" />
                </div>
                @if (this.caseItem === 'my-listings') {
                <app-filter-property-dropdown *ngIf="myProperties" class="flex flex-1 w-full max-w-[800px]"
                    [dropdownItems]="myProperties" [labelName]="t('choose-property')" [maxHeightOnDropdownOpen]="'52'"
                    [inputPlaceholder]="t('placeholder.select-property')"
                    (propertySelected)="handlePropertySelection($event)" />
                } @else if (this.caseItem === 'favorites' ) {
                <app-filter-property-dropdown class="flex flex-1 w-full max-w-[800px]"
                    [dropdownItems]="propertyFavourites" [labelName]="t('choose-property')"
                    [maxHeightOnDropdownOpen]="'52'" [inputPlaceholder]="t('placeholder.select-property')"
                    (propertySelected)="handlePropertySelection($event)" />
                } @else if (this.caseItem === 'enter-code' ) {
                <div class="flex w-full max-w-[800px]">
                    <div class="flex flex-col gap-2 group/input md:w-2/4 w-full">
                        <label class="flex items-center gap-2 text-gray-950 font-semibold">{{t('property-code')}}
                            <span class="text-error">*</span><i customTooltip [tooltipTemplate]="tooltipTemplate"
                                tooltipImg="../../../../assets/img/property-code-guide.png"
                                class="relative icon-info-circle text-tone-06 text-xl"></i>
                        </label>

                        <ng-template #tooltipTemplate>
                            {{t('custom-tooltip.title')}}
                        </ng-template>
                        <input (change)="handleTypedPropertyId($event)"
                            class="flex items-start text-left px-4 py-3 border-[1px] rounded-full bg-white text-md text-black border-gray-300" />
                    </div>
                </div>
                }
                }
                @else if (isLoading) {
                <div class="w-full h-full my-5">
                    <app-loader [withBackground]="false" variant="secondary" [width]="120"></app-loader>
                </div>
                }
            </div>

        </div>

    </div>
    <app-navigation-buttons [HidePrevious]="true" [HideSkip]="true" [HideExit]="true"
        (NextButtonClicked)="proceedToCheckout()" (PreviousButtonClicked)="navigationBack()"></app-navigation-buttons>
</ng-container>